<script setup lang="ts">
import {PropType} from "vue";
import {useApp} from "~/store/useApp";
import {LANG_HE} from "~/config/langCode";

defineProps({
  title: {
    type: String as PropType<string>
  },
  description: {
    type: String as PropType<string>
  },
  styles: {
    type: String as PropType<string>,
    default: ''
  },
  tabindex: {
    type: Number as PropType<number>,
    required: true
  }
})

const store = useApp()

const rtl = store.apiData?.JobInfo.LanguageId === LANG_HE ? 'rtl' : 'ltr'

function removeTags(text: string) {
  const regX = /(<([^>]+)>)/ig
  return text.replaceAll(regX, "").replaceAll('&nbsp', "")
}

</script>

<template>
  <div class="px-[18px] flex flex-cols">
    <div :class="[`grow pt-[28px] pb-[11px] px-[33px] bg-bg rounded-[15px] lg:w-[760px] w-[92vw] ${styles}`]">
      <div class="text-main font-bold text-[19px]" :dir="rtl" :tabindex="tabindex">
        {{ title }}
      </div>
      <div
          v-if="description"
          :aria-label="removeTags(description)"
          v-html="description.replaceAll('\r\n', '<br>')"
          :tabindex="tabindex + 1"
      />
      <slot/>
    </div>
  </div>
</template>
<style>
ul {
  list-style: disc;
}

ol {
  list-style: decimal;
}
</style>

